import React from "react";
import PropTypes from "prop-types";

import style from "./style.module.scss";

export function HintsLeft(props) {
  const className = `${style.hintsLeft} ${props.className}`;
  return (
    <p tabIndex={props.tabIndex} className={className}>
      {props.hintsLeft} Hints Left.
    </p>
  );
}

HintsLeft.propTypes = {
  /**
   * classname for custom style of component
   */
  className: PropTypes.string,
  /**
   * number of hints left
   */
  hintsLeft: PropTypes.number,
  /**
   * for keyboard navigation
   */
  tabIndex: PropTypes.number,
};

HintsLeft.defaultProps = {
  className: "",
  tabIndex: -1,
};
